import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './style.scss'

const MAX_SIZE_DEFAULT = 20

class RowIsMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMore: false,
      isMore: false
    };
  }

  componentDidMount () {
    const { text } = this.props
    if (text && text.length > 20) this.setState({hasMore: true})
  }

  onToogleIsMore = () => {
    const { isMore } = this.state
    this.setState({isMore: !isMore})
  }

  splitMessage = (text) => {
    const { maxSize } = this.props
    if (!text) return ""
    if (text.length > maxSize || MAX_SIZE_DEFAULT) {
      return text.slice(0, maxSize || MAX_SIZE_DEFAULT)
    }
    return text

  }

  render() {
    const { t, text } = this.props;
    const { isMore, hasMore } = this.state;

    const renderDescription = () => {
      if (isMore) {
        return ( 
          <div  className='animate-delay-2'>
            {text} <a onClick={() => this.onToogleIsMore()} className="cursor-pointer">{t('Leer menos')}</a>
          </div>
        )
      }
      return (
        <>
          {this.splitMessage(text)}... <a onClick={() => this.onToogleIsMore()} className="cursor-pointer">{t('Leer más')}</a>
        </>
      )

    }

    if (!hasMore) return (text)
    return (
      <>
      {renderDescription()}
      </>
    )
  }
}


export default compose(
  withTranslation(),
  connect(null, null)
)(RowIsMore);
